import { render, staticRenderFns } from "./purchaseAndSaleFirstDetail.vue?vue&type=template&id=57d7bd67&scoped=true"
import script from "./purchaseAndSaleFirstDetail.vue?vue&type=script&lang=js"
export * from "./purchaseAndSaleFirstDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseAndSaleFirstDetail.vue?vue&type=style&index=0&id=57d7bd67&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d7bd67",
  null
  
)

export default component.exports